import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import './NuevoEstablecimiento.css';
import EstablecimientoService from '../../services/establecimiento.service';
import PaisService from '../../services/pais.service';
import CadenaService from '../../services/cadena.service';
import Select from 'react-select'
import * as Constants from '../../constants';

const PopUpEstablecimiento = (props) => {

	const [listaPaises, setListaPaises] = useState([]);
	const [selectedPais, setSelectedPais] = useState(null);
	const [listaCadenas, setListaCadenas] = useState([]);
	const [selectedCadena, setSelectedCadena] = useState(null);

	const [selectedEstablecimiento, setSelectedEstablecimiento] = useState(null);

	const [nombre, setNombre] = useState('')
	const [direccionActividad, setDireccionActividad] = useState('')
	const [cpActividad, setCpActividad] = useState('')
	const [localidadActividad, setLocalidadActividad] = useState('')
	const [direccionFiscal, setDireccionFiscal] = useState('')
	const [cpFiscal, setCpFiscal] = useState('')
	const [localidadFiscal, setLocalidadFiscal] = useState('')
	const [mailAdmin, setMailAdmin] = useState('')
	const [telefonoRecepcion, setTelefonoRecepcion] = useState('')
	const [mailMantenimiento, setMailMantenimiento] = useState('')
	const [movilMantenimiento, setMovilMantenimiento] = useState('')
	const [cif, setCif] = useState('')
	const [activo, setActivo] = useState(false)
	const [permitirAsignarHabitaciones, setPermitirAsignarHabitaciones] = useState(false)

	const [nombreError, setNombreError] = useState('')
	const [paisError, setPaisError] = useState(null)
	const [cadenaError, setCadenaError] = useState(null)
	const [direccionActividadError, setDireccionActividadError] = useState('')
	const [cpActividadError, setCpActividadError] = useState('')
	const [localidadActividadError, setLocalidadActividadError] = useState('')
	const [direccionFiscalError, setDireccionFiscalError] = useState('')
	const [cpFiscalError, setCpFiscalError] = useState('')
	const [localidadFiscalError, setLocalidadFiscalError] = useState('')
	const [cifError, setCifError] = useState('')
	const [mailAdminError, setMailAdminError] = useState('')
	const [telefonoRecepcionError, setTelefonoRecepcionError] = useState('')
	const [mailMantenimientoError, setMailMantenimientoError] = useState('')
	const [movilMantenimientoError, setMovilMantenimientoError] = useState('')
	
	const [userRol, setUserRol] = useState(null);
	const userCadena = props.userCadena;

	const [t, i18n] = useTranslation("global");

	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {
		setUserRol(props.userRol);
		
		obtenerListaPaises();
		
		if(userRol !== Constants.ROLE_USUARIO_ADMIN_CADENA) {
			obtenerListaCadenas();
		}
		
		setSelectedEstablecimiento(props.selectedEstablecimiento);

		if (props.selectedEstablecimiento != null) {
			// Modo edicion

			setNombre(props.selectedEstablecimiento.nombre);
			setSelectedPais(props.selectedEstablecimiento.pais);
			setSelectedCadena(props.selectedEstablecimiento.cadena);
			setDireccionActividad(props.selectedEstablecimiento.direccionActividad);
			setCpActividad(props.selectedEstablecimiento.cpActividad);
			setLocalidadActividad(props.selectedEstablecimiento.localidadActividad);
			setDireccionFiscal(props.selectedEstablecimiento.direccionFiscal);
			setCpFiscal(props.selectedEstablecimiento.cpFiscal);
			setLocalidadFiscal(props.selectedEstablecimiento.localidadFiscal);
			setMailAdmin(props.selectedEstablecimiento.mailAdmin);
			setTelefonoRecepcion(props.selectedEstablecimiento.telefonoRecepcion);
			setMailMantenimiento(props.selectedEstablecimiento.mailMantenimiento);
			setMovilMantenimiento(props.selectedEstablecimiento.movilMantenimiento);
			setCif(props.selectedEstablecimiento.cif);
			setActivo(props.selectedEstablecimiento.activo);
			setPermitirAsignarHabitaciones(props.selectedEstablecimiento.permitirAsignarHabitaciones);
		}
		
		
	}, [props.selectedEstablecimiento, props.userRol]);

	function handleLogin(e) {
		e.preventDefault()
		// Code to handle login goes here
		props.toggle()
	}

	const obtenerListaPaises = async () => {
		await PaisService.getPaises()
			.then(response => response.json())
			.then(data => setListaPaises(data));
	}

	const obtenerListaCadenas = async () => {
		await CadenaService.getCadenas()
			.then(response => response.json())
			.then(data => setListaCadenas(data));
	}

	function validateForm(establecimiento) {

		// Set initial error values to empty  
		setNombreError('')
		setPaisError(null)
		setCadenaError(null)
		setDireccionActividadError('')
		setCpActividadError('')
		setLocalidadActividadError('')
		setDireccionFiscalError('')
		setCpFiscalError('')
		setLocalidadFiscalError('')
		setCifError('')
		setMailAdminError('')
		setTelefonoRecepcionError('')
		setMailMantenimientoError('')
		setMovilMantenimientoError('')

		if (establecimiento.nombre === '') {
			setNombreError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.pais === null) {
			setPaisError(t('app.error.campoObligatorio'))
			return;
		}
		
		if(userRol !== Constants.ROLE_USUARIO_ADMIN_CADENA && userRol !== Constants.ROLE_USUARIO_GESTOR) {
			if (establecimiento.cadena === null) {
				setCadenaError(t('app.error.campoObligatorio'))
				return false;
			}
		}

		if (establecimiento.direccionActividad === '') {
			setDireccionActividadError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.cpActividad === '') {
			setCpActividadError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.localidadActividad === '') {
			setLocalidadActividadError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.direccionFiscal === '') {
			setDireccionFiscalError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.cpFiscal === '') {
			setCpFiscalError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.localidadFiscal === '') {
			setLocalidadFiscalError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.mailAdmin === '') {
			setMailAdminError(t('app.error.campoObligatorio'))
			return;
		}

		if (!checkEmailFormat(establecimiento.mailAdmin)) {
			setMailAdminError(t('app.error.login.emailFormat'))
			return
		}

		if (establecimiento.telefonoRecepcion === '') {
			setTelefonoRecepcionError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.mailMantenimiento === '') {
			setMailMantenimientoError(t('app.error.campoObligatorio'))
			return;
		}

		if (!checkEmailFormat(establecimiento.mailMantenimiento)) {
			setMailMantenimientoError(t('app.error.login.emailFormat'))
			return
		}
		if (establecimiento.movillMantenimiento === '') {
			setMovilMantenimientoError(t('app.error.campoObligatorio'))
			return;
		}
		if (establecimiento.cif === '') {
			setCifError(t('app.error.campoObligatorio'))
			return;
		}

		if (establecimiento.id != null) {
			updateEstablecimiento(establecimiento);
		} else {
			insertEstablecimiento(establecimiento);
		}

	}

	function checkEmailFormat(email) {
		const isValidEmail = Constants.emailRegex;

		if (isValidEmail.test(email)) {
			return true;
		} else {
			return false;
		}
	}

	const guardarEstablecimiento = async () => {

		if (selectedEstablecimiento != null) {
			editarEstablecimiento(selectedEstablecimiento);
		} else {
			crearEstablecimiento();
		}

	}

	const crearEstablecimiento = async () => {

		const establecimiento = {
			nombre: nombre,
			pais: selectedPais,
			cadena: (userRol !== Constants.ROLE_USUARIO_ADMIN_CADENA) ? selectedCadena : userCadena,
			direccionActividad: direccionActividad,
			cpActividad: cpActividad,
			localidadActividad: localidadActividad,
			direccionFiscal: direccionFiscal,
			cpFiscal: cpFiscal,
			localidadFiscal: localidadFiscal,
			mailAdmin: mailAdmin,
			telefonoRecepcion: telefonoRecepcion,
			mailMantenimiento: mailMantenimiento,
			movilMantenimiento: movilMantenimiento,
			cif: cif,
			activo: true,
			permitirAsignarHabitaciones: permitirAsignarHabitaciones
		};

		validateForm(establecimiento);
	}

	const editarEstablecimiento = async (selectedEstablecimiento) => {

		const establecimiento = {
			id: selectedEstablecimiento.id,
			nombre: nombre,
			pais: selectedPais,
			cadena: selectedCadena,
			direccionActividad: direccionActividad,
			cpActividad: cpActividad,
			localidadActividad: localidadActividad,
			direccionFiscal: direccionFiscal,
			cpFiscal: cpFiscal,
			localidadFiscal: localidadFiscal,
			mailAdmin: mailAdmin,
			telefonoRecepcion: telefonoRecepcion,
			mailMantenimiento: mailMantenimiento,
			movilMantenimiento: movilMantenimiento,
			cif: cif,
			activo: activo,
			permitirAsignarHabitaciones: permitirAsignarHabitaciones
		};

		validateForm(establecimiento);
	}

	const insertEstablecimiento = async (establecimiento) => {
		await EstablecimientoService.crearEstablecimiento(establecimiento)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					props.limpiarFiltros();
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const updateEstablecimiento = async (establecimiento) => {
		await EstablecimientoService.actualizarEstablecimiento(establecimiento)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					if (props.filtroActivo != null || props.filtroCadena!= null || props.filtroNombre!== '') {
						props.loadEstablecimientosByParams(props.filtroNombre, props.filtroActivo, props.filtroCadena);
					} else {
						props.limpiarFiltros();
					}
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const cancelarEstablecimiento = () => {

		// Close popup
		props.toggle();
	}
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
}

	// Para mostrar el color de fondo de la opción elegida en la lista de Pais
	const getOptionValuePais = option => option.id;
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Cadena
	const getOptionValueCadena = option => option.id;

	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					{selectedEstablecimiento != null ? <h1 className={"popup-Title"}>{t("app.establecimiento.edicionEstablecimiento")}</h1> : <h1 className={"popup-Title"}>{t("app.establecimiento.nuevoEstablecimiento")}</h1>}
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>
				<div className="popup-Content">
					<form onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.nombre")} type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
								<label className="errorLabel">{nombreError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<Select
									getOptionValue={getOptionValuePais}
									className="selectPopupStyle"
									placeholder={t("app.label.seleccionarPais")}
									value={selectedPais}
									onChange={setSelectedPais}
									options={listaPaises}
									isSearchable={false}
									formatOptionLabel={pais => (
										<div>
											<span>{pais.nombre}</span>
										</div>
									)}
									styles={colorFiltros}
								/>
								<label className="errorLabel">{paisError}</label>
							</div>
							
							{(userRol !== Constants.ROLE_USUARIO_ADMIN_CADENA && userRol !== Constants.ROLE_USUARIO_GESTOR) && 
							(
								<div className={'inputAndSelectContainerPopup'}>
								<Select
								getOptionValue={getOptionValueCadena}
									className="selectPopupStyle"
									placeholder={t("app.label.seleccionarCadena")}
									value={selectedCadena}
									onChange={setSelectedCadena}
									options={listaCadenas}
									isSearchable={false}
									formatOptionLabel={cadena => (
										<div>
											<span>{cadena.nombre}</span>
										</div>
									)}
									styles={colorFiltros}
								/>
								<label className="errorLabel">{cadenaError}</label>
							</div>
							)}
							
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.direccionActividad")} type="text" value={direccionActividad} onChange={e => setDireccionActividad(e.target.value)} />
								<label className="errorLabel">{direccionActividadError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.cpActividad")} type="text" value={cpActividad} onChange={e => setCpActividad(e.target.value)} />
								<label className="errorLabel">{cpActividadError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.localidadActividad")} type="text" value={localidadActividad} onChange={e => setLocalidadActividad(e.target.value)} />
								<label className="errorLabel">{localidadActividadError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.direccionFiscal")} type="text" value={direccionFiscal} onChange={e => setDireccionFiscal(e.target.value)} />
								<label className="errorLabel">{direccionFiscalError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.cpFiscal")} type="text" value={cpFiscal} onChange={e => setCpFiscal(e.target.value)} />
								<label className="errorLabel">{cpFiscalError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.localidadFiscal")} type="text" value={localidadFiscal} onChange={e => setLocalidadFiscal(e.target.value)} />
								<label className="errorLabel">{localidadFiscalError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.cif")} type="text" value={cif} onChange={e => setCif(e.target.value)} />
								<label className="errorLabel">{cifError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.mailAdmin")} type="text" value={mailAdmin} onChange={e => setMailAdmin(e.target.value)} />
								<label className="errorLabel">{mailAdminError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.telefonoRecepcion")} type="text" value={telefonoRecepcion} onChange={e => setTelefonoRecepcion(e.target.value)} />
								<label className="errorLabel">{telefonoRecepcionError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.mailMantenimiento")} type="text" value={mailMantenimiento} onChange={e => setMailMantenimiento(e.target.value)} />
								<label className="errorLabel">{mailMantenimientoError}</label>
							</div>
							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.popup.label.movilMantenimiento")} type="text" value={movilMantenimiento} onChange={e => setMovilMantenimiento(e.target.value)} />
								<label className="errorLabel">{movilMantenimientoError}</label>
							</div>
							<div className={'checkboxContainerEstablecimiento'}>
								<label>{t("app.popup.label.permitirAsignarHabitaciones")}</label>
								<input type='checkbox' id='checkboxPermitirAsignarHabitaciones' checked={permitirAsignarHabitaciones} onChange={e => setPermitirAsignarHabitaciones(e.target.checked)} />
							</div>
						</div>

						{(selectedEstablecimiento != null && userRol !== Constants.ROLE_USUARIO_GESTOR) ? (
							<div className={'checkboxContainerEstablecimiento'}>
								<label>{t("app.popup.label.activo")}</label>
								<input type='checkbox' id='checkboxActivo' checked={activo} onChange={e => setActivo(e.target.checked)} />
							</div>
						) : null}

						<div className="popup-div-buttons">
							<button type="button" className="btn-general-colorPink" onClick={cancelarEstablecimiento}>{t("app.label.cancelar")}</button>
							<button type="button" className="btn-general" onClick={guardarEstablecimiento}>{t("app.label.guardar")}</button>
							<Toaster />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpEstablecimiento